/*
 * hh-cart.js - makes the Holohouse cart page update in place.
 *
 * Before this, changing a quantity required clicking "Update Cart" and reloading the
 * whole page, and "Remove" was a plain link that did the same. Every edit cost a full
 * navigation, which is where carts get abandoned.
 *
 * Behaviour:
 *   - +/- buttons, typing a quantity, and Remove all hit /cart/change.js directly.
 *   - The section is re-rendered through the Section Rendering API and swapped in as
 *     innerHTML, so the delegated listeners on the root survive the swap.
 *   - Any failure falls back to a full reload rather than leaving the customer looking
 *     at a cart that disagrees with the server.
 *   - The "Update Cart" button stays in the markup and is hidden by CSS only once this
 *     script has run, so the page still works with JS disabled.
 */
(function () {
  function init() {
    var root = document.querySelector('[data-hh-cart-section]');
    if (!root || root.dataset.hhBound) return;
    root.dataset.hhBound = '1';
    root.classList.add('hh-cart-live');

    var sectionId = root.getAttribute('data-hh-cart-section');
    var pending = null;

    function lineOf(el) {
      var item = el.closest('[data-hh-line]');
      return item ? { el: item, line: parseInt(item.getAttribute('data-hh-line'), 10) } : null;
    }

    function repaint() {
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) throw new Error('section render failed');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-hh-cart-section]');
          if (!fresh) throw new Error('section markup missing');
          // innerHTML, not replaceWith: the listeners are delegated on root and must survive.
          root.innerHTML = fresh.innerHTML;
        });
    }

    function syncHeaderCount(cart) {
      // Best effort, without depending on the theme's internal cart APIs.
      var nodes = document.querySelectorAll('.cart-bubble, [data-cart-count], .cart-count');
      for (var i = 0; i < nodes.length; i++) {
        if (/^\s*\d+\s*$/.test(nodes[i].textContent)) nodes[i].textContent = String(cart.item_count);
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    }

    function change(line, quantity, itemEl) {
      if (pending) return pending;
      if (itemEl) itemEl.classList.add('is-hh-busy');

      pending = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart change failed');
          return r.json();
        })
        .then(function (cart) {
          syncHeaderCount(cart);
          return repaint();
        })
        .catch(function () {
          window.location.reload();
        })
        .then(function () {
          pending = null;
        });

      return pending;
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hh-qty]');
      if (btn) {
        e.preventDefault();
        var ctx = lineOf(btn);
        if (!ctx) return;
        var input = ctx.el.querySelector('.hh-qty-input');
        var current = parseInt(input.value, 10) || 0;
        var next = btn.getAttribute('data-hh-qty') === 'up' ? Math.min(99, current + 1) : Math.max(0, current - 1);
        if (next === current) return;
        input.value = next;
        change(ctx.line, next, ctx.el);
        return;
      }

      var rm = e.target.closest('[data-hh-remove]');
      if (rm) {
        e.preventDefault();
        var c = lineOf(rm);
        if (c) change(c.line, 0, c.el);
      }
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('.hh-qty-input');
      if (!input) return;
      var ctx = lineOf(input);
      if (!ctx) return;
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      if (q > 99) q = 99;
      input.value = q;
      change(ctx.line, q, ctx.el);
    });

    // Enter in the quantity field applies the change instead of submitting the form.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.closest('.hh-qty-input')) {
        e.preventDefault();
        e.target.blur();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
